<template>
  <SectionPrice class="mb-5" :data="internetPhoneDataPrice">
    <template #title>
      <h2 v-if="title">
        {{ title }}
      </h2>
    </template>
    <div class="flex flex-col justify-between flex-grow">
      <span class="flex items-center justify-center">
        <span class="mx-1 text-xl font-bold">{{ props.prefix === '9' ? '162' : '252' }}</span>
        <span>هزار تومان</span>
      </span>
      <ChipsBase variant="purple" size="Small" class="mt-2 mb-4 mx-auto w-fit">راه‌اندازی رایگان</ChipsBase>
    </div>
    <div
      class="flex items-center [&>*]:w-[45%]"
      :class="hideOrder ? 'justify-center' : 'justify-between'"
    >
      <BaseButton
        v-if="!hideOrder"
        isLean
        width="full"
        text="ثبت سفارش"
        @click="showMainModal"
        :id="setIdByPath('cta')"
      />
      <BaseButtonLink
        isLean
        size="full"
        text="خرید آنلاین"
        styleType="secondary"
        to="/online-shopping/internet-phone/"
        :id="setIdByPath('onlineShopping')"
      />
    </div>
  </SectionPrice>
</template>

<script setup>
const props = defineProps({
  title: String,
  prefix: String,
  hideOrder: Boolean,
});

const internetPhoneDataPrice = {
  id: 3,
  title: "",
  label: "مناسب استفاده شخصی و اینماد",
  subTitle: "جزئیات تعرفه تلفن اینترنتی نواتل",
  desc: "هزینه تلفن ثابت اینترنتی نواتل شامل هزینه خط، کانال همزمانی و اشتراک، با پرداخت به صورت سالانه است.",
  featuers: props.prefix === '9' 
    ? [
      {
        id: "1",
        text: `قیمت شماره‌های نواتلی از 300 هزار تومان شروع شده و براساس نوع شماره (برنزی، نقره‌ای، طلایی) متغیر است.`,
        noTik: true,
      },
    ]
    : [
      {
        id: "1",
        text: `قیمت شماره‌های نواتلی از 500 هزار تومان شروع شده و براساس نوع شماره (برنزی، نقره‌ای، طلایی) متغیر است.`,
        noTik: true,
      },
    ],
  noTitleMargin: true,
  // offPrice: "۲/۲۴۰/۰۰۰",
};

const modalsStore = useModalsStore();

const showMainModal = () => {
  modalsStore.openModal('CTA');
};
</script>
